import * as config from "config-api";
import { fetch } from "../../index";
import { relatedItemsQuery } from "../../queries/relatedItems";
import { relatedItemsVideoContentItemsQuery } from "../../queries/relatedItems";
import { HttpError } from "../../../../utils/errors/http";
import { HTTP_BAD_REQUEST } from "../../../../constants/http";

const GRAPHQL_BASE_URL = config.getString("Client.contentApi.baseGraphqlURL");

export const fetchRelatedItems = (polopolyId, algorithmId) => {
    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: relatedItemsQuery(polopolyId, algorithmId),
        },
        false
    );
};

export const getMoreLikeThis = (
    relatedVideoMediaId,
    pageSize,
    algorithmId = null
) => {
    if (!relatedVideoMediaId) {
        return Promise.reject(
            new HttpError(HTTP_BAD_REQUEST, "Bad clip id supplied")
        );
    }

    const graphqlQuery = relatedItemsVideoContentItemsQuery(algorithmId);
    const graphqlVariables = {
        algorithmId: algorithmId,
        sourceId: relatedVideoMediaId,
        formats: ["video"],
        first: pageSize,
    };

    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: graphqlQuery,
            variables: { ...graphqlVariables },
        },
        false
    );
};
